import { Injectable, inject } from '@angular/core';
import { StorageEncryptor } from '@app/domain/ports/storage-encryptor.port';
import { EncryptionService } from '@app/services/encryption.service';

/**
 * Adapter que delega al EncryptionService legacy (Base64).
 * Existe únicamente para mantener compatibilidad de lectura/escritura
 * con datos ya cifrados en sessionStorage.
 *
 * Será reemplazado por una implementación con Web Crypto API (AES-GCM).
 */
@Injectable()
export class LegacyStorageEncryptorAdapter extends StorageEncryptor {
  private readonly legacy = inject(EncryptionService);

  encrypt(value: string): string {
    return this.legacy.encrypt(value);
  }

  decrypt(encrypted: string): string {
    return this.legacy.decrypt(encrypted);
  }
}
